import { faPenField } from "@fortawesome/pro-solid-svg-icons"
import {
  Box,
  FormControlLabel,
  Switch,
  Typography
} from "@mui/material"
import TextField from "@mui/material/TextField"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useApi } from "auth/useApi3"
import { AppContext } from "components/AppContextProvider"
import { useFormikContext } from "formik"
import { apiEndpoints } from "generated/apiEndpoints"
import React, { useContext, useEffect, useState } from "react"
import { CategorySidebarProps, CustomFieldCategory } from "./userCustomField.interfaces"
import { userCustomFieldCategoryValidationSchema } from "./userCustomFieldValidationSchema"
import { Sidebar } from "components/sidedrawer/Sidebar2";
import { StyledListItem } from "shared/styled/General"
import { StyledInputLabel } from "components/Form/FormComponents/FormSwitch/FormSwitch.styled"
import { useTranslation } from "react-i18next"

const initialFormikValues: CustomFieldCategory = {
  id: 0,
  name: "",
  active: true,
  customerId: 0
}

const FormStuff = () => {
  const { values, setFieldValue, handleChange, handleBlur, touched, errors } = useFormikContext<CustomFieldCategory>()
  const { t } = useTranslation()

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <StyledListItem>
        <StyledInputLabel>
          <Typography variant="h6" color={"black"}>
            {t("global.name", "Name")}
          </Typography>
        </StyledInputLabel>

        <TextField
          placeholder={t("global.set_name_on_category", "Enter category name")}
          autoComplete="off"
          fullWidth
          type="text"
          id="name"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.name && errors.name ? true : false}
          helperText={touched.name && errors.name ? errors.name : null}
          variant="outlined"
        />


      </StyledListItem>
      <StyledListItem>
        <FormControlLabel
          control={
            <Switch
              onChange={(event) => {
                setFieldValue("active", event.target.checked)
              }}
              checked={values.active}
            />
          }
          label={t("global.active", "Active")}
        />
      </StyledListItem>
    </Box>
  )
}

const formId = "CustomFieldCategoryForm";

export const UserCustomFieldCategorySidebar = ({ clickedCategory, handleSubmit }: CategorySidebarProps) => {
  const [customerResult, customerApi] = useApi() as [IApiResult, IApiFunc]
  const [categoryResult, categoryApi] = useApi() as [IApiResult, IApiFunc]
  const [formikValues, setFormikValues] = useState<CustomFieldCategory>(initialFormikValues)
  const formRef = React.useRef<any>()
  const appContext = useContext(AppContext)
  const { t } = useTranslation()

  useEffect(() => {
    customerApi.get(apiEndpoints.customeradmin.getcustomer)
  }, [])

  useEffect(() => {
    if (categoryResult.status !== 2) return
    appContext.toggleSideBar(formId, false)
    handleSubmit()
  }, [categoryResult])

  useEffect(() => {
    if (appContext.isSidebarOpen) return
    setFormikValues(initialFormikValues)
    formRef.current.resetForm()
  }, [appContext.isSidebarOpen])

  useEffect(() => {
    if (!clickedCategory) return
    setFormikValues(clickedCategory)
  }, [clickedCategory])

  const handleFormikSubmit = (formikValues: CustomFieldCategory) => {
    const customFieldCategoryData: CustomFieldCategory = {
      name: formikValues.name,
      active: formikValues.active,
      customerId: customerResult.data.id
    }
    if (clickedCategory) {
      const url = apiEndpoints.usercustomfieldsadmin.updateusercustomfieldcategory
      customFieldCategoryData.id = clickedCategory.id
      categoryApi.put(url, customFieldCategoryData)
    } else {
      const url = apiEndpoints.usercustomfieldsadmin.createusercustomfieldcategory
      categoryApi.post(url, customFieldCategoryData)
    }
  }

  return (
    <Sidebar
      initialFormikValues={formikValues}
      setInitialFormikValues={setFormikValues}
      formResult={categoryResult}
      handleSubmit={handleFormikSubmit}
      validationSchema={userCustomFieldCategoryValidationSchema(t)}
      formData={{
        formId: formId,
        titleNew: t("global.create_category", "Create category"),
        subTitleNew: t("settings.user.create_a_new_category_for_custom_fields", "Create a new category for custom fields"),
        titleEdit: `${t("global.edit", "Edit")} ${clickedCategory ? clickedCategory.name : ""}`,
        subTitleEdit: t("settings.user.change_category_values", "Change category values"),
        submitText: t("global.save", "Save"),
        submitEditText: t("global.save", "Save"),
        icon: faPenField
      }}
      formRef={formRef}
    >
      <FormStuff />
    </Sidebar>
  )
}
